import { memoizeReduxState } from '@range.io/functional'
import CollaborationSelectors from './persisted-state/collaboration-slice/collaboration-selectors.js'
import filterCollaborations from './redux-filter-common.js'

/*
 * Filter the TaskList that meet the taskListFilterSettings. This is ALL the collaborations
 * that meet the filter criteria, not just the ones on the selected canvas.
 * @sig _filteredTaskList :: State -> [Collaboration]
 * memoized as filteredTaskList below
 */
const _filteredTaskList = state => {
    const filterByCanvas = collaboration => {
        if (selectedCanvases.length === 0) return true // the user hasn't yet selected any canvases to filter by: all pass
        return selectedCanvases.some(canvas => canvas.id === collaboration.canvasId) // has ANY required canvas
    }

    const { selectedUserId, taskListFilterSettings } = state
    const { shouldFilterByCanvas, selectedCanvases } = taskListFilterSettings

    const allCollaborations = CollaborationSelectors.collaborationsAsLookupTable(state)

    // Filter to only have tasks
    let collaborations = Object.values(allCollaborations).filter(c => !!c.isTask)

    // Apply canvas filter specific to task list view
    if (shouldFilterByCanvas) collaborations = collaborations.filter(filterByCanvas)

    // Apply common filters
    collaborations = filterCollaborations(collaborations, taskListFilterSettings, selectedUserId)

    return collaborations
}

/*
 * Memoize the _filteredTaskList function, recomputing only if any of the collections or filters has changed
 */
const filteredTaskList = memoizeReduxState(
    [
        'taskListFilterSettings',

        'canvases',
        'categories',
        'collaborations',
        'geometries',
        'selectedCanvas',
        'uploads', // we need this so when upload image URLs get updated this also gets refreshed
        'statusNames',
    ],
    _filteredTaskList
)
export { filteredTaskList }
